/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_Overlap_HintInputs */

const en_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust the start and end times to avoid overlap. Fix all overlaps by running Format -> Fix Event Overlap`)
};

const fr_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustez les temps de debut et de fin pour eviter le chevauchement. Corrigez tous les chevauchements via Format -> Fix Event Overlap`)
};

const de_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passen Sie Start- und Endzeit an, um Überschneidungen zu vermeiden. Beheben Sie alle Überschneidungen mit „Format“ → „Ereignisüberschneidungen beheben“.`)
};

const it_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regola l'ora di inizio e di fine per evitare sovrapposizioni. Correggi tutte le sovrapposizioni eseguendo Formato -> Correggi sovrapposizione eventi`)
};

const ru_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отрегулируйте время начала и окончания, чтобы избежать наложения. Исправьте все наложения, выполнив команду Формат -> Исправить наложение событий.`)
};

const es_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste las horas de inicio y fin para evitar solapamientos. Corrija todos los solapamientos ejecutando Formato -> Corregir solapamiento de eventos.`)
};

const zh_cn2_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整开始时间和结束时间以避免重叠。运行“格式化”->“修复事件重叠”来修复所有重叠部分。`)
};

const ja_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間と終了時間が重複しないように調整してください。「フォーマット」→「イベントの重複を修正」を実行して、すべての重複を修正してください。`)
};

const hi_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप से बचने के लिए प्रारंभ और समाप्ति समय को समायोजित करें। फ़ॉर्मेट -> इवेंट ओवरलैप ठीक करें कमांड चलाकर सभी ओवरलैप को ठीक करें।`)
};

const pt_pt2_error_nav_event_overlap_hint = /** @type {(inputs: Error_Nav_Event_Overlap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste os horários de início e término para evitar sobreposições. Corrija todas as sobreposições executando Formatar -> Corrigir Sobreposição de Eventos.`)
};

/**
* | output |
* | --- |
* | "Adjust the start and end times to avoid overlap. Fix all overlaps by running Format -> Fix Event Overlap" |
*
* @param {Error_Nav_Event_Overlap_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_overlap_hint = /** @type {((inputs?: Error_Nav_Event_Overlap_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_Overlap_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_event_overlap_hint(inputs)
	if (locale === "de") return de_error_nav_event_overlap_hint(inputs)
	if (locale === "it") return it_error_nav_event_overlap_hint(inputs)
	if (locale === "ru") return ru_error_nav_event_overlap_hint(inputs)
	if (locale === "es") return es_error_nav_event_overlap_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_event_overlap_hint(inputs)
	if (locale === "ja") return ja_error_nav_event_overlap_hint(inputs)
	if (locale === "hi") return hi_error_nav_event_overlap_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_event_overlap_hint(inputs)
	return en_error_nav_event_overlap_hint(inputs)
});